import * as ActionTypes from '../../actions'
import {
    Action,
    ViolationDetailType
} from "../../types";

const violationDetailDefaultState = {
    videoUrl: [],
    violationDate: '',
    violationImage: '',
    plateNumber: '',
    carType: '',
    color: '',
    colorString: '',
    violationType: '',
    plateImageUrl: '',
    imageUrl: '',
};

const speedEntry = {
    time: '',
    id: ''
};

const averageSpeed = {
    value: 0,
    unit: '',
    distance: 0,
    ts_diff: 0,
    entry: speedEntry,
    exit: speedEntry
};

const spotSpeed = {
    value: 0,
    unit: '',
    id: '',
    entry: speedEntry,
    exit: speedEntry,
};

const speedDefaultState = {
    avgSpeed: averageSpeed,
    spotSpeed: spotSpeed
};

const violationState = {
    id: '',
    violationDate: '',
    vehicleSummary: '',
    violationType: '',
    violationImage: '',
    violationVideoUrl: '',
    violationDetail: violationDetailDefaultState,
    speedInfo: speedDefaultState,
};

const defaultState = {
    hasError: false,
    isLoading: false,
    violation: violationState,
    detailType: ''
};



export default function(state: ViolationDetailType = defaultState, action: Action) {
    const { type, payload } = action;

    switch (type) {
        case ActionTypes.LOAD_VIOLATION_DETAIL:
            return {
                ...state,
                isLoading: true,
                hasError: false
            };
        case ActionTypes.LOAD_VIOLATION_DETAIL_SUCCESS: {
            const { violation } = payload;

            return {
                isLoading: false,
                hasError: false,
                violation
            };
        }
        case ActionTypes.LOAD_VIOLATION_DETAIL_FAILURE:
            return {
                ...state,
                isLoading: false,
                hasError: true
            };
        default: {
            return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/violationHistory/violationDetail.ts